// src/components/AccountMenu.tsx
import React from "react";
import {
  Avatar,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Flex,
  Text,
  Badge,
  useDisclosure,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/useAuthStore";
import { useTaskStore } from "../store/useTaskStore";
import { UserSelectorModal } from "./UserSelectorModal";
import { buildAssetUrl } from "../utils/assetUrl";
import { adminUrl } from "../utils/appOrigins";

export const AccountMenu: React.FC = () => {
  const navigate = useNavigate();
  const { isOpen: isModalOpen, onOpen: onOpenModal, onClose: onCloseModal } = useDisclosure();
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const clearTask = useTaskStore.getState().setSelectedTask;

  const handleLogout = () => {
    logout();
    clearTask(null);
    localStorage.removeItem("jwt");
    sessionStorage.removeItem("jwt");
    localStorage.removeItem("user");
    sessionStorage.removeItem("user");
    document.cookie = "jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    navigate("/logout", { replace: true });
  };

  const isDemo = user?.isDemo === true;
  const displayName = user?.username || "Guest";
  const avatarSrc = buildAssetUrl(user?.user_profile_image);

  return (
    <>
      <Menu>
        <MenuButton
          cursor="pointer"
          border="none"
          background="transparent"
          _hover={{
            "& .chakra-avatar": {
              boxShadow: "0 0 20px rgba(113, 219, 255, 0.6)",
              borderColor: "rgba(113, 219, 255, 0.8)", _light: { boxShadow: "var(--paper-lift)", borderColor: "rgba(122, 31, 26, 0.4)" }
            },
          }}
        >
          <Avatar
            size="sm"
            name={displayName}
            src={avatarSrc}
            bg="teal.500"
            color="white"
            borderColor={isDemo ? "yellow.300" : "transparent"}
            borderWidth={isDemo ? 2 : 0}
            transition="all 0.2s"
            sx={{
              "& .chakra-avatar__initials": {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
              },
            }}
          />
        </MenuButton>

        <MenuList>
          <Flex direction="column" px={4} py={2}>
            <Flex align="center">
              <Text fontWeight="bold" mr={2}>
                {displayName}
              </Text>
              {isDemo && (
                <Badge colorScheme="yellow" fontSize="0.6em">
                  Demo
                </Badge>
              )}
            </Flex>
            <Text fontSize="sm" color="gray.500">
              {isDemo ? "Read‑only preview" : user?.email}
            </Text>
          </Flex>
          <MenuDivider />
          <MenuItem onClick={() => navigate("/account")}>Account Settings</MenuItem>
          {!isDemo && (
            <MenuItem as="a" href={adminUrl()} color="cyan.300" fontWeight="bold" _light={{ color: "cyan.700" }}>
              Administration
            </MenuItem>
          )}
          <MenuItem onClick={onOpenModal}>Switch Viewer</MenuItem>
          <MenuDivider />
          <MenuItem onClick={handleLogout} color="red.300" fontWeight="bold" _light={{ color: "red.700" }}>
            Log out
          </MenuItem>

        </MenuList>
      </Menu>

      <UserSelectorModal isOpen={isModalOpen} onClose={onCloseModal} />
    </>
  );
};
